/*eslint no-script-url: 0 */
import React, { Component } from "react";
import FilerobotImageEditor from 'filerobot-image-editor';
import Constants from '../../Config/Config';
import $ from 'jquery';

const apiBaseUrl = Constants.URL.root + '/webservices/uploadCanavasCroppedImage.php';

export default class ImageEditor extends Component {

    constructor(props, context) {
        super(props, context);
        this.toggleFalse = this.toggleFalse.bind(this);
        this.saveImage = this.saveImage.bind(this);
    }

    toggleFalse() {
        this.props.lgClose()
    }

    saveImage(completeData) {
        var self = this;
        // Filerobot passes { status, imageMime, imageName, canvas } to onBeforeComplete
        var canvasThumb = completeData && completeData.canvas ? completeData.canvas : document.getElementById("scaleflex-image-edit-box");
        if (!canvasThumb || typeof canvasThumb.toDataURL !== 'function') {
            console.log('Unable to get image data. Please try again.');
            return false;
        }

        self.props.dispatch({
            type: 'SET_STATE',
            state: {
                libraryImageUploading: true,
            }
        })

        $.ajax(apiBaseUrl, {
            method: "POST",
            data: { croppedImage: canvasThumb.toDataURL() },
            success: function (res) {
                self.dispatchImageData(res);
                var NImage = new Image();
                NImage.src = res
                NImage.onload = function () {
                    var O = (NImage.src.replace(/.*?:\/\//g, '/'), 0);
                    var P = 0;
                    //var Q;
                    O = NImage.width
                    P = NImage.height
                    /* if (150 < O / 30) {
                        Q = P / O;
                        O = 4500
                        P = O * Q
                    }
                    if (100 < P / 30) {
                        Q = P / O;
                        P = 3000
                        O = P * Q
                    } */
                    self.props.dispatch({
                        type: 'SET_STATE',
                        state: {
                            aspectRatio: parseFloat(NImage.width) / parseFloat(NImage.height),
                            frameImageHeight: (P / 30).toFixed(1),
                            frameImageWidth: (O / 30).toFixed(1),
                            uploadedImageHeight: (P / 30).toFixed(1),
                            uploadedImageWidth: (O / 30).toFixed(1),
                            libraryImageUploading: false,
                        }
                    })
                }
            },
            error: function (err) {
                alert('Error uploading the image, please try again with different image!')
                self.props.dispatch({
                    type: 'SET_STATE',
                    state: {
                        libraryImageUploading: false,
                    }
                })
            }
        });
        // Cancel default download; we upload via ajax instead
        return false;
    }

    dispatchImageData(ImageData) {
        const data = ImageData;
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                frameImage: data,
                uploadedFile: data
            }
        })
    }

    render() {
        const { lgShowState, uploadedFile } = this.props;

        var config = {};
        config.tools = ['resize', 'crop', 'adjust', 'effects', 'filters', 'rotate', 'text'];
        config.colorScheme = 'light';
        config.translations = {
            en: {
                'toolbar.resize': 'Image Resize',
                'toolbar.download': 'Frame It'
            }
        };

        return (
            <FilerobotImageEditor
                show={lgShowState}
                src={uploadedFile}
                onClose={this.toggleFalse}
                onBeforeComplete={this.saveImage}
                config={config}
            />
        );
    }
}